import { Box, Flex, Text } from "@chakra-ui/react";
import CorporateAproveDecline from "./CorporateAproveDecline";

const CorporateDirModal = ({ corporateDetails }) => {
  return (
    <>
      <Box h={"60vh"} overflow={"scroll"}>
        {corporateDetails?.principalDirectorInformation?.map(
          (director, index) => (
            <Box key={index} mb={6}>
              {[
                { title: "Address:", description: director.address },
                { title: "First Name:", description: director.firstName },
                { title: "Phone Number:", description: director.phoneNumber },
                {
                  title: "Special IT Interest:",
                  description: director.specialITInterest,
                },
                { title: "Surname:", description: director.surname },
                { title: "Title:", description: director.title },
              ].map((data, idx) => (
                <Flex
                  key={idx}
                  px={[1, null, null]}
                  fontSize={"18px"}
                  fontWeight={"500"}
                  fontFamily={"roboto"}
                  justifyContent={"flex-start"}
                  alignItems={"center"}
                  mb={2}
                  gap={[6, 3, 3]}
                >
                  <Text width={"35%"} color={"#121212"} fontWeight={"400"}>
                    {data.title}
                  </Text>
                  <Text width={"65%"} color={"#7A7A7A"}>
                    {data.description || "N/A"}
                  </Text>
                </Flex>
              ))}
            </Box>
          )
        )}
        {!corporateDetails?.memberCategory && (
          <CorporateAproveDecline corporateDetails={corporateDetails} />
        )}
      </Box>
    </>
  );
};

export default CorporateDirModal;
